//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {}
  },
  props: {
    data: {
      default: []
    }
  },
  computed: {
    getListStyle () {
      let len = this.data.length
      const width = 100 / len
      return `width: ${width}%`
    }
  },
  methods: {
    selectBarClick (item) {
      this.data.forEach(e => {
        e.display = false
      })
      item.display = true
      this.$emit('currentChange', item)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/simple/appSelectBar/App-select-bar.vue